import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  hideScrollbar: {
    padding: '0px',
    overflowX: 'auto',
    display: 'flex',
    scrollbarWidth: 'none', // Hide scrollbar in Firefox
    '&::-webkit-scrollbar': {
      display: 'none', // Hide scrollbar in WebKit browsers
    },
  },
}));
